import { render, staticRenderFns } from "./infoSupervisionExpert.vue?vue&type=template&id=27cdfa50&scoped=true&"
import script from "./infoSupervisionExpert.vue?vue&type=script&lang=js&"
export * from "./infoSupervisionExpert.vue?vue&type=script&lang=js&"
import style0 from "./infoSupervisionExpert.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./infoSupervisionExpert.vue?vue&type=style&index=1&id=27cdfa50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cdfa50",
  null
  
)

export default component.exports